import { motion } from "framer-motion";

const variants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

// Wrapper reutilizable para animaciones fade-in-up al hacer scroll.
export const Reveal = ({ children, delay = 0, className = "", as = "div", testId }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      data-testid={testId}
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-80px" }}
      variants={variants}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay }}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
